import type { CSSProperties, FC, ReactNode } from 'react';

interface ThreeColumnActionsProps {
  left: ReactNode;
  center: ReactNode;
  right: ReactNode;
  style?: CSSProperties;
}

export const ThreeColumnActions: FC<ThreeColumnActionsProps> = ({ left, center, right, style }) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
        ...style,
      }}
    >
      <div style={{ justifySelf: 'start' }}>{left}</div>
      <div style={{ justifySelf: 'center' }}>{center}</div>
      <div style={{ justifySelf: 'end' }}>{right}</div>
    </div>
  );
};
